import { render, staticRenderFns } from "./UpdateEthicalMedicines.vue?vue&type=template&id=0e64c722&"
import script from "./UpdateEthicalMedicines.vue?vue&type=script&lang=ts&"
export * from "./UpdateEthicalMedicines.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports